import { pdfDialogAction } from 'redux/slices/pdfDialog';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { DocumentData } from 'models/DocumentLibrary';

const useProfileEditorDialog = () => {
    const dispatch = useAppDispatch();
    const pdfDialogState = useAppSelector((state) => state.pdfDialog);

    const showPdfUploadDialog = (open: boolean) => {
        dispatch(
            pdfDialogAction.setUploadDialogOpen({
                open: open,
            })
        );
    };

    const showPdfEditDialog = (open: boolean, document: DocumentData) => {
        dispatch(
            pdfDialogAction.setEditDialogOpen({
                open: open,
                document: document,
            })
        );
    };

    const setPdfUploadDialogClosedWithSuccess = (boolean: boolean) => {
        dispatch(pdfDialogAction.setPdfUploadDialogClosedWithSuccess(boolean));
    };

    const setPdfEditDialogClosedWithSuccess = (boolean: boolean) => {
        dispatch(pdfDialogAction.setPdfEditDialogClosedWithSuccess(boolean));
    };

    const closeAllDialog = () => {
        showPdfUploadDialog(false);
        showPdfEditDialog(false, null);
    };

    return {
        pdfDialogState: pdfDialogState,
        pdfDialogStates: pdfDialogState.dialog,
        pdfUploadDialogClosedWithSuccess:
            pdfDialogState.pdfUploadDialogClosedWithSuccess,
        pdfEditDialogClosedWithSuccess:
            pdfDialogState.pdfEditDialogClosedWithSuccess,
        setPdfUploadDialogClosedWithSuccess,
        setPdfEditDialogClosedWithSuccess,
        showPdfUploadDialog,
        showPdfEditDialog,
        closeAllDialog,
    };
};

export default useProfileEditorDialog;
